import useSWRImmutable from 'swr/immutable'

import { useLocale } from 'stores/UserStore'
import { fetchPolylines } from 'services/Polylines'

export const usePolylines = () => {
    const locale = useLocale()

    const key = ['/geospatial/hwylines' + locale]

    const { data, isLoading } = useSWRImmutable(key, () => fetchPolylines(locale))

    if (isLoading) {
        return null
    }

    return data.data
}
